 <!--
  2019-2-14, AJK, created file
  2019-2-20, AJK, updated to check for match between old and new password
  2019-3-06, AJK, updated to use snotify 
 -->


<template>
  <div class="users container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"/>
    <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <div class="column is-one-third">
            <div class="card-container">
              <h1 class="title">Change Password</h1>
                <p class="has-text-danger" v-if="$route.query.redirect">
                    You must update your password first.
                </p>
              <b-field label="Original Password" >
                <b-input type="password" name="originalPassword" v-model="passwordData.originalPassword" required/>
              </b-field>
              <b-field label="New Password">
                <b-input type="password" name="newPassword" v-model="passwordData.newPassword" required/>
              </b-field>
              <b-field label="Confirm Password">
                <b-input type="password" name="confirmPassword" v-model="passwordData.confirmPassword" required/>
              </b-field>
              <p class="has-text-danger">{{passwordMatchMsg}}</p>
              <div class="columns columns-button is-mobile is-multiline" >
                <div class="column column-button-left">
                    <router-link v-show="!passwordChangeNeeded" class="button is-danger is-fullwidth is-outlined" :to="{ name: 'login', params: {userID: userID}}">Cancel</router-link>
                </div>
                <div class="column column-button-right">
                    <button :disabled="passwordMatchMsg" class="button is-primary is-fullwidth">Change Password</button>
                </div>
              </div>
            </div>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
// import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'

import { mapGetters } from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
  components:{
  },
  name: 'changePasswordForm',
  props: ['passwordChangeNeeded'],
  data () {
    return {
        passwordData: {
            recID: this.$route.params.recID,
            originalPassword: null,
            newPassword: null,
            confirmPassword: null
        },
        errorMsg: null,
        userID: this.$route.params.userID,
        isLoading: false,
        isFullPage: true,
        notificationDuration: 4000
    }
  },
  
  computed: {
    ...mapState([
      'existingPassword'
    ]),

    passwordMatchMsg: function(){
      if (this.passwordData.newPassword === this.passwordData.originalPassword){
        return "New password cannot match existing password"
      }
      else if( this.passwordData.newPassword == null || this.passwordData.confirmPassword == null ){
        return null;
      }
      else if ( this.passwordData.newPassword === this.passwordData.confirmPassword ){
        return null;
      }
      else{
        return "Passwords do not match";
      }
    }
  },
  
  created() {
    //test
    // fill in existing password only if resetting it after logging in
    if(this.passwordChangeNeeded){
      this.passwordData.originalPassword = this.existingPassword;
    }
    
  },
  
  methods:{
    
    onSubmit: async function(){
      this.isLoading = true
      var scriptParameters = `{
        "passwordOld" : "${this.passwordData.originalPassword}",
        "passwordNew" : "${this.passwordData.newPassword}",
        "passwordConfirm" : "${this.passwordData.confirmPassword}",
        "userID" : "${this.userID}"
      }`
      const result = await sharedAPI.runScript("Wholesale - Web Log - Change Password", scriptParameters)
      var scriptResult = JSON.parse(result.response.scriptResult)
      this.isLoading = false
      // FM error
      if(result.messages[0].code !== "0"){
        console.log("hi")
        this.$snotify.error(result.messages[0].message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }  
      // Script error
      if(scriptResult.code != 0){
        console.log("hello")
        this.$snotify.error( scriptResult.message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }
      this.$snotify.success(scriptResult.message, "Success",
        {
          showProgressBar: false,
          position: 'rightBottom',
          icon: false,
          timeout: this.notificationDuration,
          closeOnClick: true,
          bodyMaxLength: 1000
        },
        console.log("guten tag")
      )
      var newStore = {...store.state.userInfo}
      newStore.isPasswordChangeNeeded = false
      store.commit('setUserData', newStore)
      
        if(this.$route.query.redirect){
            this.isLoading = false
            this.$router.replace( this.$route.query.redirect)
        }
        else if(this.passwordChangeNeeded){
            this.isLoading = false
            this.$router.replace({ name: 'dashboard'})
        }
        else{
            this.$router.push({ name: 'dashboard'})
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.button-container{
  margin-top: 20px;
}
input{
  margin-bottom: 15px;
}
.is-danger{
    margin-right: 10px;
}
  .card-container {
    padding: 2rem;
    margin: 0px 20px 20px 20px;
  }  
  .page-title{
    margin: 0px 10px 0px 10px;
  }
  .columns-button{
     margin: 0px;
  }
  .column-button-left{
    padding: 0px;
  }
  .column-button-right{
    padding: 0px;
    flex: none;
  }
@media only screen and (min-width: 300px) {
  .columns-button{
     margin-top: 30px;
  }
  .column-button-left{
    padding: 0px;
    width: 100%;
  }
  .column-button-right{
    padding: 0px;
    width: 100%;
  }
  .button.is-primary{
    margin-top: 10px;
    width: 100%;
  }
}
</style>